import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularArrowGrowth: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-growth"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-growth icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M16.7489 3L21.3027 3.00052L21.403 3.01444L21.5018 3.04205L21.5621 3.0676C21.6413 3.10246 21.7155 3.15315 21.7808 3.21836L21.8215 3.2624L21.865 3.31878L21.9192 3.4089L21.9579 3.49922L21.977 3.5633L21.9906 3.6273L22 3.7215L22.0004 8.25389C22.0004 8.6681 21.6647 9.00389 21.2504 9.00389C20.8708 9.00389 20.557 8.72174 20.5073 8.35566L20.5004 8.25389L20.5 5.559L14.0607 11.9997C13.7944 12.266 13.3777 12.2902 13.0841 12.0724L13 11.9998L9.96969 9.08924L4.28033 14.7786C3.98744 15.0715 3.51256 15.0715 3.21967 14.7786C2.9534 14.5123 2.9292 14.0957 3.14705 13.8021L3.21967 13.7179L9.43935 7.49826C9.70561 7.23199 10.1223 7.20779 10.4159 7.42563L10.5 7.49825L13.5303 10.4088L19.438 4.5H16.7489C16.3692 4.5 16.0554 4.21785 16.0058 3.85177L15.9989 3.75C15.9989 3.3703 16.2811 3.05651 16.6472 3.00685L16.7489 3ZM3.75 18C4.16421 18 4.5 18.3358 4.5 18.75V22.25C4.5 22.6642 4.16421 23 3.75 23C3.33579 23 3 22.6642 3 22.25V18.75C3 18.3358 3.33579 18 3.75 18ZM9.5 14.75C9.5 14.3358 9.16421 14 8.75 14C8.33579 14 8 14.3358 8 14.75V22.25C8 22.6642 8.33579 23 8.75 23C9.16421 23 9.5 22.6642 9.5 22.25V14.75ZM13.75 16C14.1642 16 14.5 16.3358 14.5 16.75V22.25C14.5 22.6642 14.1642 23 13.75 23C13.3358 23 13 22.6642 13 22.25V16.75C13 16.3358 13.3358 16 13.75 16ZM19.5 11.75C19.5 11.3358 19.1642 11 18.75 11C18.3358 11 18 11.3358 18 11.75V22.25C18 22.6642 18.3358 23 18.75 23C19.1642 23 19.5 22.6642 19.5 22.25V11.75Z" />
      </svg>
    </span>
  );
};

export { RegularArrowGrowth };
